import { SESSION_FORM_DATA_KEY } from './constants';

export default class JraConfirmation {
  constructor(element) {
    var params = new URLSearchParams(window.location.search);
    var reference = params.get('reference');
    var price = element.dataset.price;

    window.sessionStorage.removeItem(SESSION_FORM_DATA_KEY);

    if (!reference || !price) {
      return;
    }

    window.dataLayer.push({
      event: 'membership_join',
      membership_price: price,
      reference: reference,
    });
  }
}
